const GENERAL_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Domains whose local-part rules disallow underscores entirely.
 * Gmail rejects underscores at signup (only letters, digits, and periods
 * are permitted): https://support.google.com/mail/answer/9211434
 * Yahoo and Microsoft (outlook.com/hotmail.com/live.com/msn.com) both
 * explicitly allow underscores, so they are intentionally excluded here.
 */
const DOMAINS_FORBIDDING_UNDERSCORE = ['gmail.com', 'googlemail.com'];

/**
 * Returns null when the email is valid, otherwise a user-facing message
 * describing why it was rejected.
 */
export function getEmailValidationError(value: string): string | null {
  if (!value || !GENERAL_EMAIL_REGEX.test(value)) {
    return 'Please enter a valid email';
  }

  const [localPart, domain] = value.split('@');
  if (DOMAINS_FORBIDDING_UNDERSCORE.includes(domain.toLowerCase()) && localPart.includes('_')) {
    return `Underscores aren't allowed in ${domain} addresses`;
  }

  return null;
}
